import axios, {AxiosInstance} from "axios";
import {LocalStorage} from 'ttl-localstorage';
import AppConfig from "@/config/appConfig";
import {dateToTTL, itExist} from "@/utils/general-utils";
import {Logs} from "@/utils/Logs";
import ApiService from "@/api/apiService";
import router from "@/router";
import {ROLES} from "@/api/models";
import {useAuthStore} from "@/store/pinia/authStore";

interface AuthenticationMeResponse {
  connected: boolean;
  // TODO : Restore when get new domain
  // XSRFToken: string;
  loginUrl?: string;
  roles?: ROLES[];
  expires?: string;
}

export default class AuthService {

  public static log = new Logs("AuthService", false);

  // TODO : Restore when get new domain
  public static COOKIE_PAYLOAD = `bo_authentication_payload`;
  public static COOKIE_ACCESS_TOKEN = `bo_authentication_token`;
  public static COOKIE_ROLE = `bo_authentification_roles`;

  public static auth: AxiosInstance;

  public static init(): void {
    const headers: any = {
      'IDC-Source': 'BO',
    };
    if (itExist(AuthService.getToken())) {
      headers['Authorization'] = 'Bearer ' + AuthService.getToken();
    }
    AuthService.auth = axios.create({
      baseURL: AppConfig.API_URL,
      withCredentials: true,
      headers,
    });

    AuthService.auth.interceptors.response.use((response) => {
        return Promise.resolve(response);
      }, (error) => {

        if (error?.response?.status === 401) {
          AuthService.removeAuthStorage();
          router.push({name: 'login'});
        }

        return Promise.reject(error);
      },
    );
  }

  public static async getMe(): Promise<AuthenticationMeResponse> {
    return await AuthService.auth.get(`/admin/auth/me`).then((response) => {
      // TODO : Restore when get new domain
      // LocalStorage.putSync('BO_XSRF-TOKEN', response.data.XSRFToken);
      // TODO : Add XSRF Token to Axios header
      return response.data
    });
  }

  public static async storeToken(token: string, state: string): Promise<any> {
    return AuthService.auth.post('/admin/auth/store-token', {
      token,
      state,
    }).then((r) => r.data);
  }

  public static async logout(): Promise<any> {
    // TODO : Restore when get new domain
    return await AuthService.auth.post('/admin/auth/disconnect').then((r) => r.data);
  }

  public static getToken(): string | null {
    return LocalStorage.getSync(this.COOKIE_ACCESS_TOKEN);
  }

  public static removeAuthStorage(): void {
    LocalStorage.removeKeySync(this.COOKIE_ACCESS_TOKEN);
    LocalStorage.removeKeySync(this.COOKIE_PAYLOAD);
    useAuthStore().reset();
    delete AuthService.auth.defaults.headers.Authorization
    delete ApiService.api.defaults.headers.Authorization
  }

  public static adfsLogoutRedirect(): void {
    window.location.replace("https://cid.clasp-infra.com/adfs/oauth2/logout");
  }

  // keep track of expiration for data inside the persistant store
  public static saveExpire(expires: string) {
    const expiresDate = new Date(expires);
    LocalStorage.putSync(this.COOKIE_PAYLOAD, expires, dateToTTL(expiresDate));
  }

  public static isExpired() {
    return !itExist(LocalStorage.getSync(AuthService.COOKIE_PAYLOAD));
  }

  public static removeExpire() {
    LocalStorage.removeKeySync(this.COOKIE_PAYLOAD);
  }
}
